import { ModalContext } from "app/app";
import axios from "axios";
import { FieldInput } from "components/fieldInput";
import { ViewContext } from "components/lib";
import { Form, Formik } from "formik";
import { Fragment, useContext, useState } from "react";
import Loader from "./images/loader.gif";
import styles from "./styles.module.scss";

export function BoundModal(props) {
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);
  const context = useContext(ViewContext);

  const options = [
    {
      value: "pending_cancelation",
      label: "Cancellation Pending",
    },
    {
      value: "missed_payment",
      label: "Missed Payment",
    },
  ];

  return (
    <Fragment>
      {modal.name === "bound_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Edit Requested Bind Status</div>
              <div className={styles.line} />
              <Formik
                initialValues={{
                  status: options[0].value,
                }}
                onSubmit={async (values) => {
                  setLoading(true);

                  await axios
                    .patch("/api/quote/" + modal.data.id, {
                      status: values.status,
                    })
                    .then((r) => {
                      setModal({});
                      setLoading(false);

                      context.notification.show(
                        "Quote updated successfully!",
                        "success",
                        true,
                        "toast",
                        "check-circle"
                      );

                      modal.action();
                    })
                    .catch((err) => {
                      setModal({});
                      setLoading(false);

                      context.notification.show(
                        "Failed to update quote status!",
                        "error",
                        true,
                        "toast",
                        "check-circle"
                      );
                    });
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form className={styles.form} onSubmit={handleSubmit}>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="status"
                          type="select"
                          label="Status"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          required
                          options={options}
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={{ justifyContent: "flex-end" }}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal("")}
                        >
                          Cancel
                        </button>
                        <button className={styles.save} onClick={submitForm}>
                          {loading ? (
                            <img
                              src={Loader}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : (
                            "Save"
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
